/* === CLAUDE 2026-10-01 #31 :: Panneau de recherche + popup de bienvenue === */
(function () {
  var timer, ctrl;
  function panel() { return document.getElementById('JpSearch'); }
  function open() {
    var p = panel(); if (!p) return;
    p.hidden = false; requestAnimationFrame(function () { p.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var i = p.querySelector('[data-jp-search-input]'); if (i) i.focus(); }, 50);
  }
  function close() {
    var p = panel(); if (!p) return;
    p.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { p.hidden = true; }, 300);
  }
  function run(q) {
    var p = panel(); var out = p.querySelector('[data-jp-search-out]');
    if (!q || q.trim().length < 2) { out.innerHTML = ''; return; }
    if (ctrl) ctrl.abort(); ctrl = new AbortController();
    var url = p.dataset.url + '?q=' + encodeURIComponent(q.trim()) + '&type=product&options%5Bprefix%5D=last&section_id=jp-search';
    fetch(url, { signal: ctrl.signal }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var res = doc.querySelector('[data-jp-srch-results]');
      out.innerHTML = res ? res.innerHTML : '';
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jp-search-open]') && panel()) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-jp-search-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-jp-search-clear]')) { var i = panel().querySelector('[data-jp-search-input]'); i.value = ''; run(''); i.focus(); }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-jp-search-input]')) { clearTimeout(timer); var v = e.target.value; timer = setTimeout(function () { run(v); }, 300); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel() && !panel().hidden) close(); });

  // Popup de bienvenue : une seule fois par visiteur
  function welcome() {
    var d = document.getElementById('JpWelcome'); if (!d || !d.showModal) return;
    var seen = false; try { seen = localStorage.getItem('jp_welcome_seen') === '1'; } catch (err) {}
    if (seen || window.Shopify && Shopify.designMode) return;
    setTimeout(function () { d.showModal(); }, 800);
    d.addEventListener('close', function () { try { localStorage.setItem('jp_welcome_seen', '1'); } catch (err) {} });
    d.querySelectorAll('[data-jp-welcome-dismiss]').forEach(function (b) { b.addEventListener('click', function () { try { localStorage.setItem('jp_welcome_seen', '1'); } catch (err) {} }); });
    var c = d.querySelector('[data-jp-welcome-country]'); var o = d.querySelector('[data-jp-welcome-cur]');
    if (c && o) c.addEventListener('change', function () { o.textContent = c.options[c.selectedIndex].dataset.cur; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', welcome); else welcome();
})();
/* === /CLAUDE 2026-10-01 #31 === */
